import React, { Fragment } from 'react';
import { themeGet } from '@styled-system/theme-get';
import styled, { css } from 'styled-components';

const switchTool = (name) => {
  switch (name) {
    case 'spring':
      return (
        <Fragment>
          <g clipPath="url(#clip0)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M25.8391 8.05868C23.1407 9.41124 22.5927 10.7332 22.5927 11.3172C22.5927 11.9011 23.1407 13.2231 25.8391 14.5757C25.8406 14.5764 25.8421 14.5772 25.8436 14.5779C29.047 13.793 32.5957 13.3668 36.2964 13.3668C39.9972 13.3668 43.5459 13.793 46.7493 14.5779C46.7508 14.5772 46.7523 14.5764 46.7538 14.5757C49.4522 13.2231 50.0001 11.9011 50.0001 11.3172C50.0001 10.7332 49.4522 9.41124 46.7538 8.05868C44.2306 6.79391 40.5375 5.92593 36.2964 5.92593C32.0553 5.92593 28.3623 6.79391 25.8391 8.05868ZM53.4467 16.9985C54.92 15.4771 55.9261 13.5828 55.9261 11.3172C55.9261 7.28723 52.7431 4.43211 49.4093 2.76103C45.9004 1.00217 41.2601 0 36.2964 0C31.3328 0 26.6925 1.00217 23.1836 2.76103C19.8498 4.43211 16.6668 7.28723 16.6668 11.3172C16.6668 13.5828 17.6729 15.4771 19.1462 16.9985C14.8525 19.1782 11.1113 22.7101 11.1113 27.4687C11.1113 29.5493 11.8264 31.3954 12.9903 32.9965C8.75119 35.6687 5.55556 39.4462 5.55556 44.177C5.55556 45.8371 5.94903 47.3797 6.643 48.7985C2.70391 51.7996 0 55.691 0 60.3286C0 66.6655 5.04846 71.6092 11.3983 74.7921C17.9233 78.0628 26.7303 80 36.2963 80C45.8623 80 54.6693 78.0628 61.1943 74.7921C67.5441 71.6092 72.5926 66.6655 72.5926 60.3286C72.5926 55.691 69.8887 51.7996 65.9496 48.7985C66.6436 47.3797 67.037 45.8371 67.037 44.177C67.037 39.4463 63.8415 35.6688 59.6025 32.9966C60.7664 31.3955 61.4816 29.5494 61.4816 27.4687C61.4816 22.7101 57.7404 19.1782 53.4467 16.9985ZM25.4307 20.8405C28.5715 21.9947 32.3308 22.6344 36.2964 22.6344C40.2621 22.6344 44.0214 21.9947 47.1622 20.8405C48.4568 21.2455 49.6376 21.7175 50.6822 22.2411C54.3859 24.0976 55.5557 26.1158 55.5557 27.4687C55.5557 28.2481 55.1676 29.2481 54.1306 30.3109C49.074 28.3866 42.8921 27.2904 36.2963 27.2904C29.7005 27.2904 23.5187 28.3866 18.4623 30.3108C17.4253 29.2481 17.0372 28.248 17.0372 27.4687C17.0372 26.1158 18.207 24.0976 21.9107 22.2411C22.9553 21.7175 24.1361 21.2455 25.4307 20.8405ZM17.687 37.1307C13.198 39.4554 11.4815 42.1 11.4815 44.177C11.4815 44.6531 11.5717 45.159 11.7647 45.684C16.5688 43.3429 22.5634 41.7122 29.1639 41.0238C25.444 40.4378 22.0577 39.3988 19.2552 37.994C18.7224 37.7269 18.1976 37.4391 17.687 37.1307ZM43.4289 41.0238C50.0293 41.7123 56.0239 43.3429 60.8278 45.684C61.0209 45.159 61.1111 44.6531 61.1111 44.177C61.1111 42.1001 59.3946 39.4555 54.9058 37.1308C54.3952 37.4391 53.8704 37.7269 53.3377 37.994C50.5351 39.3988 47.1488 40.4378 43.4289 41.0238ZM46.5959 34.2678C43.6318 35.1288 40.1157 35.6447 36.2964 35.6447C32.4771 35.6447 28.961 35.1288 25.9968 34.2677C29.1212 33.5973 32.6016 33.2163 36.2963 33.2163C39.9911 33.2163 43.4716 33.5974 46.5959 34.2678ZM56.5806 50.2628C51.2164 48.0029 44.1437 46.5831 36.2963 46.5831C28.4489 46.5831 21.3762 48.0029 16.012 50.2628C16.6024 50.6392 17.2578 51.0107 17.9822 51.3738C22.5161 53.6464 28.9869 55.1378 36.2963 55.1378C43.6056 55.1378 50.0765 53.6464 54.6104 51.3738C55.3348 51.0107 55.9902 50.6392 56.5806 50.2628ZM10.3459 53.4171C7.27555 55.7143 5.92593 58.1668 5.92593 60.3286C5.92593 63.2195 8.33939 66.6301 14.0538 69.4944C19.5931 72.271 27.4528 74.0741 36.2963 74.0741C45.1398 74.0741 52.9995 72.271 58.5388 69.4944C64.2532 66.6301 66.6667 63.2195 66.6667 60.3286C66.6667 58.1668 65.317 55.7143 62.2467 53.4171C60.7829 54.6755 59.0771 55.7635 57.2659 56.6714C51.7462 59.4381 44.3282 61.0637 36.2963 61.0637C28.2644 61.0637 20.8463 59.4381 15.3267 56.6714C13.5155 55.7635 11.8097 54.6755 10.3459 53.4171Z"
              fill="#1F77F9"
            />
          </g>
          <defs>
            <clipPath id="clip0">
              <rect width="72.5926" height="80" fill="white" />
            </clipPath>
          </defs>
        </Fragment>
      );
    case 'circle':
      return (
        <Fragment>
          <g clipPath="url(#clip1)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M40.5925 80C62.6839 80 80.5925 62.0914 80.5925 40C80.5925 17.9086 62.6839 0 40.5925 0C18.5012 0 0.592529 17.9086 0.592529 40C0.592529 62.0914 18.5012 80 40.5925 80ZM56.5925 24H24.5925V56H56.5925V24Z"
              fill="#28D898"
            />
          </g>
          <defs>
            <clipPath id="clip1">
              <rect
                width="80"
                height="80"
                fill="white"
                transform="translate(0.592529)"
              />
            </clipPath>
          </defs>
        </Fragment>
      );
    case 'octo':
      return (
        <Fragment>
          <g clipPath="url(#clip2)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M68.8768 11.7157L40.5925 0L12.3083 11.7157L0.592529 40L12.3083 68.2843L40.5925 80L68.8768 68.2843L80.5925 40L68.8768 11.7157ZM56.5925 24H24.5925V56H56.5925V24Z"
              fill="#FFE249"
            />
          </g>
          <defs>
            <clipPath id="clip2">
              <rect
                width="80"
                height="80"
                fill="white"
                transform="translate(0.592529)"
              />
            </clipPath>
          </defs>
        </Fragment>
      );
    case 'square':
      return (
        <Fragment>
          <g clipPath="url(#clip3)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M80.5925 0H0.592529V80H80.5925V0ZM40.5925 62.2222C52.8656 62.2222 62.8148 52.2731 62.8148 40C62.8148 27.7269 52.8656 17.7778 40.5925 17.7778C28.3195 17.7778 18.3703 27.7269 18.3703 40C18.3703 52.2731 28.3195 62.2222 40.5925 62.2222Z"
              fill="#d5ff4f"
            />
          </g>
          <defs>
            <clipPath id="clip3">
              <rect
                width="80"
                height="80"
                fill="white"
                transform="translate(0.592529)"
              />
            </clipPath>
          </defs>
        </Fragment>
      );
    case 'allen-key':
      return (
        <Fragment>
          <g clipPath="url(#clip4)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M17.4216 8C12.5454 8 8.59253 11.9529 8.59253 16.8291V80H0.592529V16.8291C0.592529 7.53464 8.12716 0 17.4216 0H43.7925V8H17.4216Z"
              fill="#8A38F3"
            />
          </g>
          <defs>
            <clipPath id="clip4">
              <rect
                width="43.2"
                height="80"
                fill="white"
                transform="translate(0.592529)"
              />
            </clipPath>
          </defs>
        </Fragment>
      );
    case 'hexa':
      return (
        <Fragment>
          <g clipPath="url(#clip5)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M70.0745 20L35.4334 0L0.79248 20V60L35.4334 80L70.0745 60V20ZM35.4257 56C44.2622 56 51.4257 48.8365 51.4257 40C51.4257 31.1635 44.2622 24 35.4257 24C26.5891 24 19.4257 31.1635 19.4257 40C19.4257 48.8365 26.5891 56 35.4257 56Z"
              fill="#1F77F9"
            />
          </g>
          <defs>
            <clipPath id="clip5">
              <rect
                width="69.2821"
                height="80"
                fill="white"
                transform="translate(0.79248)"
              />
            </clipPath>
          </defs>
        </Fragment>
      );
    case 'wrench':
      return (
        <Fragment>
          <g clipPath="url(#clip6)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M25.1166 0C10.3761 6.4404 0.074707 21.149 0.074707 38.2635C0.074707 61.3139 18.7608 80 41.8112 80C64.8616 80 83.5475 61.3139 83.5475 38.2635C83.5475 21.149 73.2462 6.44043 58.5057 2.08797e-05V38.1651C58.5057 47.3853 51.0313 54.8597 41.8112 54.8597C32.591 54.8597 25.1166 47.3853 25.1166 38.1651V0Z"
              fill="#28D898"
            />
          </g>
          <defs>
            <clipPath id="clip6">
              <rect
                width="83.4728"
                height="80"
                fill="white"
                transform="translate(0.074707)"
              />
            </clipPath>
          </defs>
        </Fragment>
      );
    default:
      return null;
  }
};

const switchViewBox = (name) => {
  switch (name) {
    case 'spring':
      return '0 0 73 80';
    case 'circle':
    case 'octo':
    case 'square':
      return '0 0 81 80';
    case 'allen-key':
      return '0 0 44 80';
    case 'hexa':
      return '0 0 71 80';
    case 'wrench':
      return '0 0 84 80';
    default:
      return '0 0 0 0';
  }
};

const Svg = styled.svg`
  ${(p) => css`
    path {
      fill: ${themeGet(`colors.${p.$color}`, p.$color)};
    }
  `}
`;

export default function ToolKitFix({ name, size, color, ...props }) {
  const viewBox = switchViewBox(name);
  const [, , defaultWidth, defaultHeight] = viewBox.split(' ');

  return (
    <Svg
      width={size || defaultWidth}
      height={size ? '100%' : defaultHeight}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      $color={color}
      {...props}>
      {switchTool(name)}
    </Svg>
  );
}
